<div id="rightSideBar">
    <div class="overLayDiv active" *ngIf="isOverlayRequired"></div>
    <div id="mileage-rate-setting-guide" class="rightSidePanel bg-grey-1"
        [ngClass]="{'active':this.ukMileageRateSettingConfiguration.isOverlayEnabled==true}">
        <form [formGroup]="formctrl" autocomplete="off" (ngSubmit)="onSubmit()">
            <header class="panel-header">
                <div class="viewDemo title-and-video">
                    <h2>{{this.ukMileageRateSettingConfiguration.panelHeading}}</h2>
                </div>
                <div *ngIf="PanelData && !PanelData.isFromExternalPanel" class="panel-left-btn">
                    <button type="button"
                        *ngIf="formData?.totalActiveVehicle && !this.ukMileageRateSettingConfiguration.isCopyIconHide"
                        (click)="fnOpenAssignVehicleForClaimant()" class="btn eod-btn-outline-warning mr-2">
                        {{ 'show_all_vehicle' | translate: param }} ({{formData?.totalActiveVehicle}})
                    </button>
                    <button type="button" *ngIf="fnDisplayAddRateButton()"
                        (click)="fnShowConfigureshowLoggingAlertPanel()" class="btn eod-btn-outline-warning mr-2">
                        {{ 'label_log' | translate: param }}
                    </button>
                    <button type="button" (click)="this.fnOpenDeleteRateConfirmationBox(this.orgUKMileageRateInfo); "
                        *ngIf="!this.ukMileageRateSettingConfiguration.isDeleteRateBtnHide && !(this.formData?.rowData?.uniqueRowId>0)"
                        class="btn eod-btn-outline-warning mr-2">
                        {{ 'label_delete' | translate: param }}
                    </button>
                    <button type="button" (click)="this.fnCopyExistingRate();"
                        class="btn eod-btn-outline-warning height-38px mr-2"
                        *ngIf="!this.ukMileageRateSettingConfiguration.isCopyIconHide && !(this.formData?.rowData?.uniqueRowId>0)">
                        {{ 'uk_mileage_copy' | translate: param }}
                    </button>
                    <button type="submit" class="btn eod-btn-primary height-38px mr-2 disabled"
                        [ngClass]="{'disabled':this.fnDisabledSave()}">
                        {{ 'label_save' | translate: param }}
                    </button>
                    <button type="button" (click)="closePanel();" class="btn eod-btn-outline-warning height-38px">
                        {{ 'label_close' | translate: param }}
                    </button>
                </div>
                <div class="panel-left-btn" *ngIf="PanelData && PanelData.isFromExternalPanel">
                    <button type="button" *ngIf="fnDisplayAddRateButton()"
                        (click)="fnShowConfigureshowLoggingAlertPanel()"
                        class="btn eod-btn-outline-warning height-38px mr-2">
                        {{ 'label_log' | translate: param }}
                    </button>
                    <button type="submit" class="btn eod-btn-primary height-38px mr-2 disabled"
                        [ngClass]="{'disabled':this.fnDisabledSave()}">
                        {{ 'label_save' | translate: param }}
                    </button>
                    <button type="button" (click)="closePanel();" class="btn eod-btn-outline-warning height-38px">
                        {{ 'label_close' | translate: param }}
                    </button>
                </div>
            </header>
            <div class="eod-panel-body">
                <div class="height-40px" *ngIf="!this.ukMileageRateSettingConfiguration.isActiveLogIconHide 
                && PanelData && !PanelData.isFromExternalPanel">
                    <div class="toggleSwitch float-left padding-right-0 lH-20 margin-left-5">
                        <div class="custom-control custom-switch toggleSwitch">
                            <input type="checkbox" class="custom-control-input align-middle" id="customSwitches"
                                (change)="this.activateValueChanged($event)" formControlName="isActive">
                            <label
                                class="custom-control-label bigToggle cursor-pointer f-20 fw-600 lH-25 padding-top-5 padding-left-15"
                                for="customSwitches">
                                {{ (this.formctrl.value.isActive ? 'turn_off': 'turn_on') | translate:param }}
                            </label>
                        </div>
                    </div>

                </div>
                <div class="block margin-top-5" *ngIf="!this.ukMileageRateSettingConfiguration.isOwnershipTypeHide">
                    <div class="row padding-top-10">
                        <div class="col-md-12 col-sm-12 no-padding-right-left">

                            <div class="input-group">
                                <ng-select formControlName="derivedName" #derivedName class="solo-dropdown"
                                    [items]="activeVehicleTypeDropdown" bindLabel="derivedName" bindValue="derivedName"
                                    placeholder="{{ 'uk_mileage_ownership_type_select' | translate: param }}"
                                    [selectOnTab]="true" [clearable]="false" (change)="fnSetVehicleTypeValue($event)"
                                    notFoundText="{{ 'no_data_available' | translate: param }}">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block padding-top-0 margin-top-0"
                    [ngClass]="{'disabled':PanelData && PanelData.isFromExternalPanel}"
                    *ngIf="!this.ukMileageRateSettingConfiguration.isOwnershipTemplate_NameBlockhide">
                    <div class="row padding-top-5">
                        <div class="col-md-6 col-sm-6 padding-left-0 ng-select-margin">

                            <div class="input-group">
                                <ng-select formControlName="concatVehicleTypeId" #concatVehicleTypeId
                                    class="solo-dropdown" [items]="vehicleTypeMasterInfoList" bindLabel="baseName"
                                    bindValue="concatVehicleTypeId"
                                    [readonly]="this.ukMileageRateSettingConfiguration.isOwnershipTemplateDisable"
                                    placeholder="{{ 'uk_mileage_ownership_template' | translate: param }}"
                                    [selectOnTab]="true" [clearable]="false"
                                    (change)="fnSetOwnershipTemplateValue($event)"
                                    notFoundText="{{ 'no_data_available' | translate: param }}">
                                </ng-select>

                            </div>
                        </div>

                        <div class="col-md-6 col-sm-6 padding-right-0">
                            <div class="input-group" placement="left" >
                                <div>
                                    <input type="text" class="form-control" formControlName="vehicleLabel" #vehicleLabel
                                        maxlength="50" (keyup)="fnOwnershipNameKeyPress($event)"
                                        [ngClass]="{ 'has-value': vehicleLabel.value,'disabled color-grey':this.ukMileageRateSettingConfiguration.isOwnershipNameDisable }">
                                    <label for="vehicleLabel">
                                        {{ 'variant_name' | translate:param }}<span>*</span>
                                    </label>
                                </div>
                                <div *ngIf="this.ukMileageRateSettingConfiguration.submitted && formUk.vehicleLabel.errors"
                                    class="alert-danger">
                                    <div
                                        *ngIf="formUk.vehicleLabel.errors.required && this.ukMileageRateSettingConfiguration.submitted">
                                        <b>{{ 'required_validation' | translate:param }}</b>
                                    </div>
                                </div>
                                <div *ngIf="this.ukMileageRateSettingConfiguration.isOwnershipNameDuplicate">
                                    <div class="alert-danger">
                                        <b>{{ 'ownership_name_already_exist' | translate:param }}</b>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div class="block padding-top-0 pb-0"
                    [hidden]="this.ukMileageRateSettingConfiguration.isEffictiveFromBlockhide">

                    <div class="row padding-top-10">
                        <div class="col-md-6 col-sm-6 padding-left-0" >
                            <div class="input-group"
                                [ngClass]="{'disabled color-grey':this.ukMileageRateSettingConfiguration.isEffictiveFromDisabled}">

                                <input class="form-control has-value" #fFrmDate formControlName="effectiveFrom"
                                    (change)="this.fnValidateEffectiveDate($event);" readonly />

                                <label for="fFrmDate">
                                    {{ 'uk_mileage_effective_from' | translate:param }}<span>*</span>
                                </label>
                                <app-calendar-icon></app-calendar-icon>
                                <div *ngIf="this.ukMileageRateSettingConfiguration.submitted && formUk.effectiveFrom.errors"
                                    class="alert-danger">
                                    <div
                                        *ngIf="formUk.effectiveFrom.errors.required && this.ukMileageRateSettingConfiguration.submitted">
                                        <b>{{ 'required_validation' | translate:param }}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 padding-right-0">
                            <div class="input-group"
                                *ngIf="this.ukMileageRateSettingConfiguration.isResetBussMileDisplay">
                                <input type="text" class="form-control color-blue font-weight-bold disabled color-grey"
                                    formControlName="resetDate" #resetDate [ngClass]="{'has-value': resetDate.value }">
                                <label for="taxCode">
                                    {{ 'uk_mileage_reset_miles_on' | translate:param }}<span>*</span>
                                </label>
                            </div>

                        </div>
                    </div>
                </div>


                <div class="block block padding-top-0"
                    [hidden]="!this.ukMileageRateSettingConfiguration.isSlabsDivDisplay || isElectricCar">
                    <div class="row padding-top-10" *ngIf="PanelData && PanelData.highlightEditRate">
                        <h6 class="fw-600 color-orange">{{"update_cost_of_fuel"|translate}}</h6>
                    </div>
                    <div class="row padding-top-10">
                        <div class="col-md-6 col-sm-6 padding-left-0">
                            <div class="input-group">
                                <input [hidden]="!isFCassignedToOwnership" type="Text" class="form-control has-value"
                                    formControlName="nrFuelRate" #nrFuelRate
                                    (input)="setMaxFuelRate($event.target.value)" maxlength="11" min="0.0001"
                                    [max]="maxFuelRate" numeric decimals="4"
                                    [ngClass]="{'disabled color-grey':this.ukMileageRateSettingConfiguration.isCostOfFuelDisable }" />
                                <input [hidden]="isFCassignedToOwnership" type="Text" class="form-control has-value"
                                    formControlName="nrFuelRate" #nrFuelRate
                                    (input)="setMaxFuelRate($event.target.value)" maxlength="11" min="0.0"
                                    [max]="maxFuelRate" numeric decimals="4"
                                    [ngClass]="{'disabled color-grey':this.ukMileageRateSettingConfiguration.isCostOfFuelDisable }" />

                                <label for="nrFuelRate">
                                    {{ 'cost_of_fuel' | translate:param }}<span>*</span>
                                </label>

                                <div *ngIf="formUk.nrFuelRate.errors 
                                                      && ukMileageRateSettingConfiguration.submitted"
                                    class="alert-danger">
                                    <div *ngIf="formUk.nrFuelRate.errors.required">
                                        {{ 'required_validation' | translate:param }}
                                    </div>
                                    <div *ngIf="formUk.nrFuelRate.errors.max">
                                        {{ 'nrfc_cost_of_fuel_validation' | translate:param }}
                                    </div>
                                </div>

                                <div [hidden]="!formUk?.nrFuelRate?.errors" class="alert-danger">
                                    <div [hidden]="!formUk?.nrFuelRate?.errors?.cannotBeZero">
                                        {{ 'cost_of_fuel_not_be_zero' | translate:param }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 padding-right-0 ng-select-margin">
                            <div class="input-group"
                                *ngIf="!this.ukMileageRateSettingConfiguration.isTaxRateFunctionPurchased"
                                (click)="this.fnCheckRedirect();">
                                <ng-select formControlName="vatRateId" #vatRateId class="solo-dropdown"
                                    [items]="taxRateMasterResponse" bindLabel="taxCode" bindValue="taxRateMasterId"
                                    [readonly]="this.ukMileageRateSettingConfiguration.isSlabVatRateDisabled 
                                        || !this.ukMileageRateSettingConfiguration.isTaxRateFunctionPurchased"
                                    placeholder="{{ 'tax_vat_gst' | translate: param }}" [selectOnTab]="true"
                                    [clearable]="false" (change)="fnSetVatRateValue($event)"
                                    notFoundText="{{ 'no_data_available' | translate: param }}">
                                </ng-select>
                            </div>
                            <div class="input-group"
                                *ngIf="this.ukMileageRateSettingConfiguration.isTaxRateFunctionPurchased">

                                <ng-select formControlName="vatRateId" #vatRateId class="solo-dropdown"
                                    [items]="taxRateMasterResponse" bindLabel="taxCode" bindValue="taxRateMasterId"
                                    [readonly]="this.ukMileageRateSettingConfiguration.isSlabVatRateDisabled"
                                    placeholder="{{ 'tax_vat_gst' | translate}}" [clearable]="false"
                                    [selectOnTab]="true" [(ngModel)]="selectedTaxRateMasterId"
                                    (change)="fnSetVatRateValue($event)"
                                    notFoundText="{{ 'no_data_available' | translate }}">
                                    <ng-template ng-option-tmp let-item="item" let-index="index">
                                        <span class="linkOption dropdownLink" *ngIf="item.isLink">
                                            <a class="float-left d-block linkOption dropdownLink">
                                                {{ item.taxCode }}
                                            </a>
                                        </span>
                                        <span *ngIf="!item.isLink">
                                            <p class="font-weight-bold employee-role-option">{{ item.taxCode }}</p>
                                            <p class="employee-role-option">{{ item.description }}</p>
                                        </span>
                                    </ng-template>
                                </ng-select>

                                <!-- <ng-select formControlName="vatRateId" #vatRateId class="solo-dropdown"
                                    [items]="taxRateMasterResponse" bindLabel="taxCode" bindValue="taxRateMasterId"
                                    [readonly]="this.ukMileageRateSettingConfiguration.isSlabVatRateDisabled"
                                    placeholder="{{ 'tax_vat_gst' | translate: param }}" [selectOnTab]="true"
                                    [clearable]="false" (change)="fnSetVatRateValue($event)"
                                    notFoundText="{{ 'no_data_available' | translate: param }}">
                                </ng-select> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block" *ngIf="this.ukMileageRateSettingConfiguration.isSlabsDivDisplay 
                && this.ukMileageRateSettingConfiguration.isOtherCarTypeSelected && !isElectricCar">

                    <div class="row padding-top-10">
                        <div class="col-md-12 col-sm-12 no-padding-right-left">
                            <div class="input-group"
                                *ngIf="!isFCassignedToOwnership && ukMileageRateSettingConfiguration.isSlabRateDisabled"
                                ngbTooltip="{{ fnTooltipMileageRate() | translate:param }}" placement="right"
                                tooltipClass="my-custom-class-mileageRate-singleRate"
                                (click)="showMileageRateChangeAlert()">
                                <input type="text" class="form-control" formControlName="mileageRate" #mileageRate
                                    dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber [beforeDecimal]="3"
                                    [afterDecimal]="4" (input)="setMaxFuelRate($event.target.value)"
                                    [ngClass]="{'has-value': mileageRate.value,'disabled color-grey':this.ukMileageRateSettingConfiguration.isSlabRateDisabled }">
                                <label for="mileageRate">
                                    {{ 'uk_mileage_rate' | translate:param }}<span>*</span>
                                </label>
                                <div *ngIf="formUk.mileageRate.errors 
                                                    && this.ukMileageRateSettingConfiguration.submitted"
                                    class="alert-danger">
                                    <div *ngIf="formUk.mileageRate.errors.required">
                                        {{ 'required_validation' | translate:param }}
                                    </div>
                                    <div *ngIf="!formUk.mileageRate.errors.required">
                                        {{ 'msg_error_invalid_rate' | translate:param }}
                                    </div>
                                </div>
                            </div>
                            <div class="input-group"
                                *ngIf="isFCassignedToOwnership || !ukMileageRateSettingConfiguration.isSlabRateDisabled">
                                <input [hidden]="!isFCassignedToOwnership" type="text" class="form-control"
                                    formControlName="mileageRate" #mileageRate
                                    dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber [beforeDecimal]="3"
                                    [afterDecimal]="4" (input)="setMaxFuelRate($event.target.value)"
                                    [ngClass]="{'has-value': mileageRate.value}">

                                <input [hidden]="isFCassignedToOwnership" type="text" class="form-control"
                                    formControlName="mileageRate" #mileageRate
                                    dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber [beforeDecimal]="3"
                                    [afterDecimal]="4" (input)="setMaxFuelRate($event.target.value)"
                                    [ngClass]="{'has-value': mileageRate.value,'disabled color-grey':this.ukMileageRateSettingConfiguration.isSlabRateDisabled }">
                                <label for="mileageRate">
                                    {{ 'uk_mileage_rate' | translate:param }}<span>*</span>
                                </label>
                                <div *ngIf="formUk.mileageRate.errors 
                                                    && this.ukMileageRateSettingConfiguration.submitted"
                                    class="alert-danger">
                                    <div *ngIf="formUk.mileageRate.errors.required">
                                        {{ 'required_validation' | translate:param }}
                                    </div>
                                    <div *ngIf="!formUk.mileageRate.errors.required">
                                        {{ 'msg_error_invalid_rate' | translate:param }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="block" *ngIf="this.ukMileageRateSettingConfiguration.isSlabsDivDisplay 
                    && this.ukMileageRateSettingConfiguration.isPrivateCarTypeSelected && !isElectricCar">
                    <div class="row margin-top-0">
                        <div class="col-md-12 no-padding-right-left margin-top-0">
                            <div class="row ">
                                <h6 class="color-orange">{{ 'uk_mileage_add_rate' | translate:param }}
                                    <span *ngIf="this.ukMileageRateSettingConfiguration.isRangeToValidationDisplay"
                                        class="f-13 right-0 position-absolute color-red font-weight-bold">
                                        {{ 'range_from_and_range_to_validation_message' | translate:param }}</span>
                                </h6>

                                <div class="table-responsive overFlow-y-Scroll-hide">
                                    <table class="table table-striped margin-top-0 tableBodyScroll">
                                        <thead>
                                            <tr class="position-relative;">
                                                <th style="width: 15%;">{{ 'uk_mileage_tier' | translate:param }}
                                                </th>
                                                <th class="text-right" style="width: 25%;">{{
                                                    'uk_mileage_range_from' | translate:param }}
                                                </th>
                                                <th class="text-right" style="width: 5%;">&nbsp;</th>
                                                <th class="text-right" style="width: 25%;">{{ 'uk_mileage_range_to'
                                                    | translate:param }}
                                                </th>
                                                <th class="text-right" style="width: 5%;">&nbsp;</th>
                                                <th class="text-right" style="width: 25%;">{{ 'uk_mileage_rate' |
                                                    translate:param }}</th>
                                                <th style="width: 5%;"
                                                    *ngIf="claims.RateType == this.mileageRateTypeEnum.DifferentialRate">
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody id="expTableValues" formArrayName="mileageMultiRateInfoList">
                                            <tr *ngFor="let innerItem of mileageMultiRateInfoListArray.controls; let i=index"
                                                [formGroupName]="i">
                                                <td style="width: 15%;">{{'uk_mileage_tier' | translate:param}}
                                                    {{i+1}}
                                                </td>

                                                <td style="width: 25%;">
                                                    <input type="text" formControlName="rangeFrom" #rangeFrom readonly 
                                                        tabindex="-1"
                                                        class="w-100pc disabled mileageRateInputEdit mileageRateInputEdit-borderGrey text-right padding-right-5"
                                                        maxlength="6">
                                                </td>
                                                <td class="text-right" style="width: 5%;">&nbsp;</td>
                                                <td style="width: 25%;"
                                                    *ngIf="this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled">
                                                    <input type="text" formControlName="rangeTo" #rangeTo
                                                        [readonly]="this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled"
                                                        [attr.tabindex]="this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled ? -1 : null"
                                                        class="mileageRateInputEdit w-100pc text-right padding-right-5"
                                                        [ngClass]="{'disabled mileageRateInputEdit-borderGrey':this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled}">
                                                </td>
                                                <td style="width: 25%;"
                                                    *ngIf="!this.ukMileageRateSettingConfiguration.isSlabRangeToDisabled">
                                                    <input type="text" formControlName="rangeTo" #rangeTo maxlength="6"
                                                        class="mileageRateInputEdit w-100pc text-right padding-right-5"
                                                        numeric
                                                        [ngClass]="{'mileageRateInputEdit-Error': this.mileageMultiRateInfoListArray.at(i).get('isRangeToInvalid').value}"
                                                        (change)="this.fnCalculateRangeForPrivateCar();">
                                                    <div *ngIf="mileageMultiRateInfoListArray.controls[i].get('rangeTo').errors?.required 
                                                    && this.ukMileageRateSettingConfiguration.submitted"
                                                        class="alert-danger">
                                                        <div>
                                                            <b>{{ 'required_validation' | translate:param }}</b>
                                                        </div>
                                                    </div>

                                                </td>
                                                <td class="text-right" style="width: 5%;">&nbsp;</td>
                                                <td style="width: 25%;"
                                                    *ngIf="ukMileageRateSettingConfiguration.isSlabRateDisabled"
                                                    ngbTooltip="{{ 'mileage_rate_msg1' | translate:param }}"
                                                    placement="left" tooltipClass="my-custom-class-mileageRate">
                                                    <input type="text" value="0.13" maxlength="9"
                                                        *ngIf="claims.RateType == this.mileageRateTypeEnum.DifferentialRate"
                                                        dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber
                                                        [beforeDecimal]="3" [afterDecimal]="4"
                                                        (input)="setMaxFuelRate($event.target.value)"
                                                        formControlName="mileageRate" #mileageRate
                                                        class="mileageRateInputEdit w-100pc text-right padding-right-5"
                                                        [ngClass]="{'disabled mileageRateInputEdit-borderGrey':this.ukMileageRateSettingConfiguration.isSlabRateDisabled }">
                                                    <input type="text" value="0.13" maxlength="9" min="0.01"
                                                        *ngIf="claims.RateType != this.mileageRateTypeEnum.DifferentialRate"
                                                        dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber
                                                        [beforeDecimal]="3" [afterDecimal]="4"
                                                        (input)="setMaxFuelRate($event.target.value)"
                                                        formControlName="mileageRate" #mileageRate
                                                        class="mileageRateInputEdit w-100pc text-right padding-right-5"
                                                        [ngClass]="{'disabled mileageRateInputEdit-borderGrey':this.ukMileageRateSettingConfiguration.isSlabRateDisabled }">

                                                    <div *ngIf="mileageMultiRateInfoListArray.controls[i].get('mileageRate').errors 
                                                        && this.ukMileageRateSettingConfiguration.submitted"
                                                        class="alert-danger">
                                                        <div
                                                            *ngIf="mileageMultiRateInfoListArray.controls[i].get('mileageRate').errors.required">
                                                            <b>{{ 'required_validation' | translate:param }}</b>
                                                        </div>
                                                        <div
                                                            *ngIf="!mileageMultiRateInfoListArray.controls[i].get('mileageRate').errors.required">
                                                            {{ 'msg_error_invalid_rate' | translate:param }}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style="width: 25%;"
                                                    *ngIf="!ukMileageRateSettingConfiguration.isSlabRateDisabled">
                                                    <input type="text" value="0.13" maxlength="9"
                                                        *ngIf="claims.RateType == this.mileageRateTypeEnum.DifferentialRate"
                                                        dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber
                                                        [beforeDecimal]="3" [afterDecimal]="4"
                                                        (input)="setMaxFuelRate($event.target.value)"
                                                        formControlName="mileageRate" #mileageRate
                                                        class="mileageRateInputEdit w-100pc text-right padding-right-5"
                                                        [ngClass]="{'disabled mileageRateInputEdit-borderGrey':this.ukMileageRateSettingConfiguration.isSlabRateDisabled }">
                                                    <input type="text" value="0.13" maxlength="9" min="0.01"
                                                        *ngIf="claims.RateType != this.mileageRateTypeEnum.DifferentialRate"
                                                        dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber
                                                        [beforeDecimal]="3" [afterDecimal]="4"
                                                        (input)="setMaxFuelRate($event.target.value)"
                                                        formControlName="mileageRate" #mileageRate
                                                        class="mileageRateInputEdit w-100pc text-right padding-right-5"
                                                        [ngClass]="{'disabled mileageRateInputEdit-borderGrey':this.ukMileageRateSettingConfiguration.isSlabRateDisabled }">

                                                    <div *ngIf="mileageMultiRateInfoListArray.controls[i].get('mileageRate').errors 
                                                        && this.ukMileageRateSettingConfiguration.submitted"
                                                        class="alert-danger">
                                                        <div
                                                            *ngIf="mileageMultiRateInfoListArray.controls[i].get('mileageRate').errors.required">
                                                            <b>{{ 'required_validation' | translate:param }}</b>
                                                        </div>
                                                        <div
                                                            *ngIf="!mileageMultiRateInfoListArray.controls[i].get('mileageRate').errors.required">
                                                            {{ 'msg_error_invalid_rate' | translate:param }}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td *ngIf="claims.RateType == this.mileageRateTypeEnum.DifferentialRate"
                                                    style="width: 5%;" class="text-right padding-right-5 color-red"
                                                    (click)="deleteMileageMultiRateInfoFromList(i)"
                                                    [ngClass]="{'disabled':this.ukMileageRateSettingConfiguration.isSlabDeleteRateDisabled || i==0  }"
                                                    data-placement="left"><i class="fas fa-trash-alt disabled"></i>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                    <span *ngIf="this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled
                                    && claims.RateType == this.mileageRateTypeEnum.DifferentialRate"
                                        [ngClass]="{'disabled pointer-auto':this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled }"
                                        (mouseover)="this.ukMileageRateSettingConfiguration.isAddSlabHover=true"
                                        (mouseout)="this.ukMileageRateSettingConfiguration.isAddSlabHover=false">
                                        <span
                                            [ngClass]="{'disabled':this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled }">
                                            <button type="button" class="btn btn-primary f-12"
                                                (click)="addMileageMultiRateInfo();"><span class="padding-right-5"><i
                                                        class="far fa-plus-circle" aria-hidden="true"></i></span>
                                                {{ 'uk_mileage_add_tier' | translate:param }}
                                            </button>
                                        </span>
                                    </span>

                                    <span *ngIf="!this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled
                                    && claims.RateType == this.mileageRateTypeEnum.DifferentialRate"
                                        [ngClass]="{'disabled':this.ukMileageRateSettingConfiguration.isSlabAddTierRateDisabled || !mileageMultiRateInfoListArray.valid }"
                                        data-placement="left">
                                        <button type="button" class="btn btn-primary f-12"
                                            (click)="addMileageMultiRateInfo();"><span class="padding-right-5"><i
                                                    class="far fa-plus-circle" aria-hidden="true"></i></span>
                                            {{ 'uk_mileage_add_tier' | translate:param }}
                                        </button>

                                    </span>
                                    <p class="helpText helpText-addSlab"
                                        [ngClass]="{'active':this.ukMileageRateSettingConfiguration.isAddSlabHover}"
                                        *ngIf="this.ukMileageRateSettingConfiguration.isAddSlabHover">
                                        <span>{{ 'uk_mileage_add_new_slab_validation_msg' | translate:param
                                            }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="block"
                    *ngIf="claims.RateType == 1 && this.ukMileageRateSettingConfiguration.isSlabsDivDisplay">
                    <span>
                        <strong>
                            {{ 'note' | translate}}
                        </strong>
                    </span>
                    <ul class="info-panel">
                        <li class="border-bottom  ">
                            <p>
                                <span>
                                    <i class="fas fa-info-circle text-mustard f-12" aria-hidden="true">
                                    </i>
                                </span>
                                <span class="padding-left-5">
                                    {{ 'mileage_rate_msg3' | translate:param }}
                                </span>
                            </p>
                        </li>

                    </ul>

                </div>
                
                <div class="block" *ngIf="isElectricCar && this.ukMileageRateSettingConfiguration.isSlabsDivDisplay">
                    <div class="mb-3 pb-3 border-bottom">
                        <p  class="fw-600">{{ 'electric_vehicle_charging_rates' | translate }}</p>
                        <small>{{ 'configure_rates_per_charging_type' | translate }}</small>
                    </div>
                    <div class="border rounded mb-3">
                        <div class="py-2 px-3 border-bottom">
                            <p class="fw-600">{{ 'electric_car_msg_1' | translate }}</p>
                            <small>{{ 'electric_car_msg_2' | translate }}</small>
                        </div>
                        <div class="py-2 px-3">
                            <div class="input-group margin-top-25">
                                <input type="text" class="form-control has-value disabled py-1 h-auto color-grey" disabled value="3.59">
                                <label>{{ 'electric_car_msg_1' | translate }}<span>*</span></label>
                                <small class="color-grey fw-600 f-12">{{ 'electric_car_msg_3' | translate }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex gap-3" formArrayName="mileageMultiRateInfoList">
                        <div class="mileage-cr --primary" [formGroupName]="0">
                            <div class="mileage-cr-header">
                                <div class="mileage-cr-header-text">
                                    <p>{{ 'electric_car_msg_4' | translate }}</p>
                                    <small>{{ 'home_charging_at_residence' | translate }}</small>
                                </div>
                                <div class="d-flex">
                                    <input type="checkbox" switch="bool" id="toggle-home-charging"
                                        [(ngModel)]="homeChargingEnabled" [ngModelOptions]="{standalone: true}"
                                        (change)="formctrl.markAsDirty(); fnUpdateElectricCardValidators(0)">
                                    <label class="mb-0 cursor-pointer" for="toggle-home-charging"></label>
                                </div>
                            </div>
                            <div class="mileage-cr-content">
                                <div class="input-group margin-top-25">
                                    <input type="text" class="form-control" formControlName="mileageRate"
                                        #mileageRateHome dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber
                                        [beforeDecimal]="3" [afterDecimal]="4"
                                        (input)="fnSetMaxFuelRateForElectricCard(0)"
                                        [ngClass]="{'has-value': mileageRateHome.value}">
                                    <label>{{ 'electric_car_msg_6' | translate:param }} {{claims?.mileageUOM}})<span>*</span></label>
                                    <div *ngIf="mileageMultiRateInfoListArray.at(0).get('mileageRate').errors
                                        && ukMileageRateSettingConfiguration.submitted && homeChargingEnabled"
                                        class="alert-danger">
                                        <div *ngIf="mileageMultiRateInfoListArray.at(0).get('mileageRate').errors.required">
                                            {{ 'required_validation' | translate:param }}
                                        </div>
                                        <div *ngIf="mileageMultiRateInfoListArray.at(0).get('mileageRate').errors.cannotBeZero">
                                            {{ 'electric_car_msg_10' | translate:param }}
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group margin-top-30">
                                    <input type="text" class="form-control" formControlName="nrFuelRate" #nrFuelRateHome
                                        dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber [beforeDecimal]="3"
                                        [afterDecimal]="4"
                                        (input)="fnSetMaxFuelRateForElectricCard(0)"
                                        [ngClass]="{'has-value': nrFuelRateHome.value}">
                                    <label>{{ 'electric_car_msg_7' | translate:param }}<span>*</span></label>
                                    <div *ngIf="mileageMultiRateInfoListArray.at(0).get('nrFuelRate').errors
                                        && ukMileageRateSettingConfiguration.submitted && homeChargingEnabled" class="alert-danger">
                                        <div *ngIf="mileageMultiRateInfoListArray.at(0).get('nrFuelRate').errors.required">
                                            {{ 'required_validation' | translate:param }}
                                        </div>
                                        <div *ngIf="mileageMultiRateInfoListArray.at(0).get('nrFuelRate').errors.max">
                                            {{ 'electric_car_msg_8' | translate:param }}
                                        </div>
                                        <div *ngIf="mileageMultiRateInfoListArray.at(0).get('nrFuelRate').errors.cannotBeZero">
                                            {{ 'electric_car_msg_9' | translate:param }}
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group margin-top-10 mb-2">
                                    <ng-select formControlName="vatRateId" class="solo-dropdown"
                                        [items]="taxRateMasterResponse" bindLabel="taxCode" bindValue="taxRateMasterId"
                                        placeholder="{{ 'tax_vat_gst' | translate: param }}" [clearable]="false"
                                        [selectOnTab]="true" (change)="fnSetVatRateValueForElectricCard($event, 0)">
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <span class="linkOption dropdownLink" *ngIf="item.isLink">
                                                <a class="float-left d-block linkOption dropdownLink">
                                                    {{ item.taxCode }}
                                                </a>
                                            </span>
                                            <span *ngIf="!item.isLink">
                                                <p class="font-weight-bold employee-role-option">{{ item.taxCode }}</p>
                                                <p class="employee-role-option">{{ item.description }}</p>
                                            </span>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <div class="mileage-cr --warning" [formGroupName]="1">
                            <div class="mileage-cr-header">
                                <div class="mileage-cr-header-text">
                                    <p>{{ 'electric_car_msg_5' | translate }}</p>
                                    <small>{{ 'public_charging_stations' | translate }}</small>
                                </div>
                                <div class="d-flex">
                                    <input type="checkbox" switch="bool" id="toggle-3party-charging"
                                        [(ngModel)]="thirdPartyChargingEnabled" [ngModelOptions]="{standalone: true}"
                                        (change)="formctrl.markAsDirty(); fnUpdateElectricCardValidators(1)">
                                    <label class="mb-0 cursor-pointer" for="toggle-3party-charging"></label>
                                </div>
                            </div>
                            <div class="mileage-cr-content">
                                <div class="input-group margin-top-25">
                                    <input type="text" class="form-control" formControlName="mileageRate" #mileageRate3p
                                        dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber [beforeDecimal]="3"
                                        [afterDecimal]="4"
                                        (input)="fnSetMaxFuelRateForElectricCard(1)"
                                        [ngClass]="{'has-value': mileageRate3p.value}">
                                    <label>{{ 'electric_car_msg_6' | translate:param }} {{claims?.mileageUOM}})<span>*</span></label>
                                    <div *ngIf="mileageMultiRateInfoListArray.at(1)?.get('mileageRate')?.errors
                                        && ukMileageRateSettingConfiguration.submitted && thirdPartyChargingEnabled"
                                        class="alert-danger">
                                        <div *ngIf="mileageMultiRateInfoListArray.at(1).get('mileageRate').errors.required">
                                            {{ 'required_validation' | translate:param }}
                                        </div>
                                        <div *ngIf="mileageMultiRateInfoListArray.at(1).get('mileageRate').errors.cannotBeZero">
                                            {{ 'electric_car_msg_10' | translate:param }}
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group margin-top-30">
                                    <input type="text" class="form-control" formControlName="nrFuelRate" #nrFuelRate3p
                                        dynamicDigitBeforeAndDynamicDigitAfterDecimalNumber [beforeDecimal]="3"
                                        [afterDecimal]="4"
                                        (input)="fnSetMaxFuelRateForElectricCard(1)"
                                        [ngClass]="{'has-value': nrFuelRate3p.value}">
                                    <label>{{ 'electric_car_msg_7' | translate:param }}<span>*</span></label>
                                    <div *ngIf="mileageMultiRateInfoListArray.at(1)?.get('nrFuelRate')?.errors
                                        && ukMileageRateSettingConfiguration.submitted && thirdPartyChargingEnabled" class="alert-danger">
                                        <div *ngIf="mileageMultiRateInfoListArray.at(1).get('nrFuelRate').errors.required">
                                            {{ 'required_validation' | translate:param }}
                                        </div>
                                        <div *ngIf="mileageMultiRateInfoListArray.at(1).get('nrFuelRate').errors.max">
                                            {{ 'electric_car_msg_8' | translate:param }}
                                        </div>
                                        <div *ngIf="mileageMultiRateInfoListArray.at(1).get('nrFuelRate').errors.cannotBeZero">
                                            {{ 'electric_car_msg_9' | translate:param }}
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group margin-top-10 mb-2">
                                    <ng-select formControlName="vatRateId" class="solo-dropdown"
                                        [items]="taxRateMasterResponse" bindLabel="taxCode" bindValue="taxRateMasterId"
                                        placeholder="{{ 'tax_vat_gst' | translate: param }}" [clearable]="false"
                                        [selectOnTab]="true" (change)="fnSetVatRateValueForElectricCard($event, 1)">
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <span class="linkOption dropdownLink" *ngIf="item.isLink">
                                                <a class="float-left d-block linkOption dropdownLink">
                                                    {{ item.taxCode }}
                                                </a>
                                            </span>
                                            <span *ngIf="!item.isLink">
                                                <p class="font-weight-bold employee-role-option">{{ item.taxCode }}</p>
                                                <p class="employee-role-option">{{ item.description }}</p>
                                            </span>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block">
                    <h6 class="note">{{ 'note' | translate}}</h6>
                    <h6 class="info-text">
                        <i class="fas fa-info-circle"></i>
                        <span>{{ 'mileage_rate_4_decimal_info' | translate }}</span>
                    </h6>

                    <div class="warning-info-section border-0">
                        <h6 class="m-0 f-14 fw-600">{{ 'trailing_zeros_header' | translate }}</h6>
                        <p>{{ 'trailing_zeros_info' | translate }}</p>
                    </div>
                </div>
            </div>
        </form>


    </div>
</div>

<div id="rightSideBar">
    <div class="overLayDiv" [ngClass]="{'active':this.ukMileageRateSettingConfiguration.isEffectiveFromValidation}">
    </div>
    <div class="rightSidePanel bg-grey-1"
        [ngClass]="{'active':this.ukMileageRateSettingConfiguration.isEffectiveFromValidation}">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{this.ukMileageRateSettingConfiguration.popUpModelAlertHeading}}</h2>
            </div>
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="fncloseEffictiveValidation();">
                    {{ 'label_close' | translate: param }}
                </button>
            </div>
        </header>
        <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 margin-top-10 no-padding-right-left">
            <div class="block">
                <div class="row">
                    <div class="col-md-12 padding-left-0">
                        <div>
                            {{this.ukMileageRateSettingConfiguration.popUpModelAlertContant}}
                        </div>
                    </div>

                </div>
            </div>
            <div class="">&nbsp;</div>
        </div>
    </div>
</div>

<marketing-popup *ngIf="this.ukMileageRateSettingConfiguration.showTaxMarketingPopup" [data]="taxRatePopupModel"
    (closePanel)="fnCloseMarketingPopUp()">
</marketing-popup>


<div class="overLayDiv" [ngClass]="{'active':this.ukMileageRateSettingConfiguration.isDeleteRateConfirmationDisplay}">
</div>
<div id="rightSideBar" *ngIf="this.ukMileageRateSettingConfiguration.isDeleteRateConfirmationDisplay">
    <div class="rightSidePanel d-flex flex-column">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{this.ukMileageRateSettingConfiguration.popUpModelAlertHeading}}</h2>
            </div>
        </header>
        <div class="eod-panel-body-with-footer">
            <div class="block mt-2">
                <h6 class="info-text">
                    <i class="fas fa-exclamation-circle eod-text-danger"></i>
                    <span>{{this.ukMileageRateSettingConfiguration.popUpModelAlertContant}}</span>
                </h6>
            </div>
        </div>
        <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px">
            <button type="button" class="btn eod-btn-primary" (click)="fnDeleteOrgUKMileageRateInfo();">
                {{ 'label_yes' | translate: param }}
            </button>
            <button type="button" class="btn eod-btn-outline-warning" (click)="fncloseDeleteRateConfirmationBox();">
                {{ 'label_no' | translate: param }}
            </button>
        </footer>
    </div>
</div>


<div class="overLayDiv" [ngClass]="{'active': showOwnershipAlertPopup}"></div>
<div id="rightSideBar">
    <div class="rightSidePanel" [ngClass]="{'active': showOwnershipAlertPopup}" style="z-index: 99999;">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{OwnershipAlertPopupModel.title}}</h2>
            </div>
        </header>
        <div [ngClass]="setClasses()">
            <span
                *ngIf="(OwnershipAlertPopupModel && OwnershipAlertPopupModel.message && OwnershipAlertPopupModel.message.length > 1)">
                <strong>{{ 'label_note' | translate }}:</strong>
            </span>
            <div class="row" *ngIf="OwnershipAlertPopupModel.htmlMessage.length > 1">
                <ul class="info-panel" *ngIf="OwnershipAlertPopupModel.htmlMessage.length > 1">
                    <li class="border-bottom" *ngFor="let item of OwnershipAlertPopupModel.htmlMessage">
                        <p class="text-charcoal-black lH-25">
                            <span *ngIf="item.iconClass"><i [ngClass]="item.iconClass" aria-hidden="true"></i></span>
                            <span class="padding-left-5" [innerHTML]="item.textHtml"></span>
                        </p>
                    </li>
                </ul>
            </div>
            <div class="row"
                *ngIf="OwnershipAlertPopupModel.htmlMessage.length == 0 && OwnershipAlertPopupModel.message.length > 1">
                <ul class="info-panel" *ngIf="OwnershipAlertPopupModel.message.length > 1">
                    <li class="border-bottom" *ngFor="let item of OwnershipAlertPopupModel.message">
                        <p class="text-charcoal-black lH-25">
                            <span><i class="fas fa-exclamation-circle color-red align-middle"
                                    aria-hidden="true"></i></span>
                            <span class="padding-left-5" [innerHTML]="item"></span>
                        </p>
                    </li>
                </ul>
            </div>
            <div class="row"
                *ngIf="OwnershipAlertPopupModel.htmlMessage.length == 0 && OwnershipAlertPopupModel.message.length == 1">
                <ul class="info-panel">
                    <li class="border-bottom" *ngFor="let item of OwnershipAlertPopupModel.message">
                        <p class="text-charcoal-black lH-28">
                            <span *ngIf="!hideInfoIcon"><i class="fas fa-exclamation-circle color-red align-middle"
                                    aria-hidden="true"></i></span>
                            <span class="padding-left-5" [ngClass]="singleMessageTextClass" [innerHTML]="item"></span>
                        </p>
                    </li>
                </ul>
            </div>
            <div class="row"
                *ngIf="OwnershipAlertPopupModel.htmlMessage.length == 0 && OwnershipAlertPopupModel.message.length == 0">
                <ul class="info-panel">
                    <li class="border-bottom">
                        <p class="text-charcoal-black lH-28">
                            <span><i class="fas fa-exclamation-circle color-red align-middle"
                                    aria-hidden="true"></i></span>
                            <span class="padding-left-5"
                                [innerHTML]="sanitizerHtml(OwnershipAlertPopupModel.showReviewConfirmContinuePanelText)"></span>
                        </p>
                    </li>
                </ul>
            </div>
        </div>

        <div class="d-flex position-absolute bottom-0 w-100pc justify-content-center bg-white padding-15">
            <span class="margin-right-15" *ngIf="this.OwnershipAlertPopupModel.btnCancelToolTipText!=''">
                <button type="button" class="btn btn-outline-primary bg-white fw-600 height-38px"
                    (click)="fnOwnershipAlertPopupReceiver(false)">{{this.OwnershipAlertPopupModel.btnCancelToolTipText}}
                </button>
            </span>
            <span *ngIf="formData?.totalActiveVehicle && !this.ukMileageRateSettingConfiguration.isCopyIconHide">
                <span class=" margin-right-15" *ngIf="this.OwnershipAlertPopupModel.btnOkToolTipText!=''">
                    <button type="button" class="btn btn-outline-primary"
                        (click)="fnOwnershipAlertPopupReceiver(true)">{{this.OwnershipAlertPopupModel.btnOkToolTipText}}
                    </button>
                </span>
                <span class="margin-right-0">
                    <button type="button" class="btn btn-primary" (click)="fnOpenAssignVehicleForClaimant()">
                        {{ 'show_all_vehicle' | translate: param }} ({{formData?.totalActiveVehicle}})
                    </button>
                </span>
            </span>
            <span *ngIf="!formData?.totalActiveVehicle && !this.ukMileageRateSettingConfiguration.isCopyIconHide">
                <span class=" margin-right-0" *ngIf="this.OwnershipAlertPopupModel.btnOkToolTipText!=''">
                    <button type="button" class="btn btn-primary"
                        (click)="fnOwnershipAlertPopupReceiver(true)">{{this.OwnershipAlertPopupModel.btnOkToolTipText}}
                    </button>
                </span>
            </span>

        </div>
    </div>
</div>
<app-alert-panel 
    [data]="UnsavedChangesAlertPopupModel" 
    (callbackEvent)="fnUnsavedChangesAlertPopupReceiver($event)">
</app-alert-panel>

<app-alert-panel 
    [data]="MileageRateChangeAlertPopupModel" 
    (callbackEvent)="fnMileageRateChangeAlertPopupReceiver($event)">
</app-alert-panel>

<app-tax-setup-step0 *ngIf="showStep1" [panelHeader]="panelHeader" [closeBtnText]="closeBtnText"
    [(fmSpecialObject)]="fmSpecialObject"
    (closePanelEvent)="fnCloseTaxSetup($event)">
</app-tax-setup-step0>

<app-tax-setup-step1 *ngIf="showStep2" [panelHeader]="panelHeader"
    [(fmSpecialObject)]="fmSpecialObject"
    (closePanelEvent)="fnCloseTaxSetupStep2($event)">
</app-tax-setup-step1>

<app-tax-setup-step2 *ngIf="showStep3" [panelHeader]="panelHeader" [IsSingleRate]="IsSingleRate"
    [(fmSpecialObject)]="fmSpecialObject"
    (closePanelEvent)="fnCloseTaxSetupStep3($event)">
</app-tax-setup-step2>